import { CREATED } from 'modules/common/constants/conversationStatuses';
import { fetchConversation } from 'modules/conference/actions/fetchConversation';
import { showAppointmentInfo } from 'modules/queues/common/actions/appointmentInfo';
import { fetchAppointment } from 'modules/appointmentInfo/actions/fetchAppointment';
import { onIncomingCall } from 'modules/conference/actions/_newConversationActions/onIncomingCall';
import { fetchConversationAppointments } from 'modules/conference/actions/conversationAppointments';
import { isCurrentUserConversationCreator } from 'modules/appointmentInfo/selectors/currentAppointment';
import { connectToConversation } from 'modules/conference/actions/_newConversationActions/conversationLifecircleActions';

import createAction from '../';
import { restoreConsultation } from '../startConsultation';


export const clearURLSearchParams = (history, location) => {
  return history.replace({
    pathname: location.pathname,
    search: '',
  });
};

export const CLEAR_CONVERSATION_PARAMS = createAction('CLEAR_CONVERSATION_PARAMS');

export const checkActiveConversation = (location, history) => (dispatch, getState) => {
  const { conversationId } = getState().session.sessionInfo.activeConversations[0] || {};
  let appointmentId;

  if (!conversationId) {
    return dispatch({ type: CLEAR_CONVERSATION_PARAMS });
  }

  const startConsultationId = Number(new URLSearchParams(location?.search).get('startConsultationId'));
  if (startConsultationId) {
    return dispatch(fetchConversationAppointments(startConsultationId))
      .then(appointment => appointmentId = appointment.appointmentId)
      .then(() => dispatch(fetchAppointment(appointmentId, false)))
      .then(() => dispatch(fetchConversation(startConsultationId)))
      .then(() => dispatch(connectToConversation(appointmentId, getState().appointmentInfo.currentAppointment)))
      .finally(() => clearURLSearchParams(location, history));
  }

  dispatch(fetchConversationAppointments(conversationId))
    .then(appointment => appointmentId = appointment.appointmentId)
    .then(() => dispatch(fetchAppointment(appointmentId)))
    .then(() => dispatch(fetchConversation(conversationId)))
    .then(() => {
      const state = getState();
      const { currentConversation } = state.conference;

      return (currentConversation.status === CREATED && !isCurrentUserConversationCreator(state))
        ? dispatch(onIncomingCall({ appointmentId }))
        : dispatch(showAppointmentInfo(appointmentId, true))
          .then(() => dispatch(restoreConsultation(appointmentId)));
    });
};
